import React, { Component, createContext, useContext } from "react";
import { getAllBlocks, getUsersBlock } from "../../services/getAPIs";

export const BlockMachine = createContext();
export default class ContextProvider extends Component {
  state = {
    first: "",
    allBlocks: null,
    loggedIn: null,
  };
  updateState = (state, info) => {
    this.setState({ [state]: info });
  };
  setUpBlocks = async () => {
    let res;
    try {
      res = await getAllBlocks();
      if (res.data.success) {
        this.setState({ allBlocks: res.data.data });
      } else {
        this.setState({ allBlocks: null });
      }
    } catch (error) {
      this.setState({ allBlocks: null });
    }
  };
  checkForLogin = async () => {
    let res;
    try {
      res = await getUsersBlock();
      if (res.data.success) {
        this.setState({ loggedIn: true });
      } else {
        this.setState({ loggedIn: false });
      }
    } catch (error) {
      this.setState({ loggedIn: false });
    }
  };
  componentDidMount() {
    this.setUpBlocks();
    this.checkForLogin();
  }
  render() {
    return (
      <BlockMachine.Provider
        value={{ ...this.state, updateState: this.updateState }}
      >
        {this.props.children}
      </BlockMachine.Provider>
    );
  }
}
